import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';

import { cn } from '@/lib/utils';

interface RichTextEditorProps {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  className?: string;
  minHeight?: string;
}

export function RichTextEditor({
  value,
  onChange,
  placeholder = 'Write something…',
  className,
  minHeight = '120px',
}: RichTextEditorProps) {
  const editor = useEditor({
    extensions: [StarterKit],
    content: value,
    onUpdate: ({ editor: e }) => onChange(e.getHTML()),
    editorProps: {
      attributes: {
        class: 'prose prose-sm dark:prose-invert max-w-none focus:outline-none p-3',
        style: `min-height: ${minHeight}`,
      },
    },
  });

  if (!editor) return null;

  const isEmpty = editor.isEmpty;

  return (
    <div
      className={cn(
        'relative rounded-md border border-input bg-background text-sm ring-offset-background focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2',
        className
      )}
    >
      {isEmpty && (
        <p className="pointer-events-none absolute left-3 top-3 text-sm text-muted-foreground">
          {placeholder}
        </p>
      )}
      <EditorContent editor={editor} />
    </div>
  );
}

interface RichTextDisplayProps {
  html: string | null | undefined;
  className?: string;
}

export function RichTextDisplay({ html, className }: RichTextDisplayProps) {
  if (!html) return null;
  return (
    <div
      className={cn('prose prose-sm dark:prose-invert max-w-none', className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
